const toPublicSize = ({ name, sku, inStock, capacity, price } = {}) => ({
  name,
  sku,
  inStock,
  capacity,
  price,
});

const toPublicVariation = ({ name, sku, imageUrls, attributes, sizes } = {}) => ({
  name,
  sku,
  imageUrls,
  attributes,
  sizes: Array.isArray(sizes) ? sizes.map(toPublicSize) : [],
});

/**
 * Public representation of a product for the `product` field of host page events.
 * Picks the product spec fields only, so internal fields never reach merchant handlers.
 * @param {object} args
 * @param {string} args.id Bambuser product id
 * @param {string} args.ref merchant product reference
 * @param {string} [args.currency]
 * @param {string} [args.locale]
 * @param {object} [args.product] the `product` part of a product spec
 * @return {object} JSON-safe product data
 */
export const toPublicProductData = ({ id, ref, currency, locale, product = {} }) => ({
  id,
  ref,
  currency,
  locale,
  name: product.name,
  // inheritFromPlaceholder() hydrates with an empty sku, meaning "use the reference"
  sku: product.sku || ref,
  brandName: product.brandName,
  description: product.description,
  introduction: product.introduction,
  thumbnailUrl: product.thumbnailUrl,
  defaultVariationIndex: product.defaultVariationIndex,
  variations: Array.isArray(product.variations) ? product.variations.map(toPublicVariation) : [],
});
